import {
  addFirmMember,
  configureMailbox,
  configureFirmCurvePreference,
  configureFirmEmailQuota,
  createFirm,
  deleteFirm,
  fetchFirm,
  fetchFirmCurvePreference,
  fetchFirmEmailQuota,
  fetchFirmMembers,
  fetchFirms,
  fetchPendingFirmInvitations,
  removeFirmMember,
  removeMailbox,
  removePendingFirmInvitation,
  resendFirmMemberInvitation,
  updateMemberRole,
} from "@/apis/firmsApi";

export const firmsService = {
  fetchFirms,
  createFirm,
  fetchFirm,
  deleteFirm,
  fetchFirmMembers,
  fetchPendingFirmInvitations,
  addFirmMember,
  updateMemberRole,
  removeFirmMember,
  removePendingFirmInvitation,
  resendFirmMemberInvitation,
  configureMailbox,
  removeMailbox,
  fetchFirmEmailQuota,
  configureFirmEmailQuota,
  fetchFirmCurvePreference,
  configureFirmCurvePreference,
};

